<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.changedAndMadePublicByMember.p1')}}
    {{news.textParams[2]}}
    {{$t('news.template.opinion.changedAndMadePublicByMember.p2')}}
    {{news.textParams[3]}}
    {{$t('news.template.opinion.changedAndMadePublicByMember.p3')}}
    "
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[4]}}"
    >{{ news.textParams[5] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedAndMadePublicByMember.p4')}}
    {{ news.textParams[6] }}
    {{$t('news.template.opinion.changedAndMadePublicByMember.p5')}}
    "
    <router-link :to="{name: 'OpinionView', params: {hash: news.textParams[4]}}">
      {{ news.textParams[7] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedAndMadePublicByMember.p6')}}
  </div>
</template>
